export default "__VITE_ASSET__C2Qnvnc4__"